// components
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import DatePicker from "../../components/DatePicker";
import Dialog from "../../components/Dialog";

// hooks
import { useState } from "react";
import { useHistory } from "react-router";

const PrintDialog = ({ open, onClose }) => {
  const history = useHistory();

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const dateFormat = (date) => {
    return date.format("YYYY-MM-DD");
  };
  const goToPrint = () => {
    if (fromDate && toDate) {
      history.push(`/print/${dateFormat(fromDate)}/${dateFormat(toDate)}`);
    }
  };

  const setPrintDates = (from, to) => {
    setFromDate(from);
    setToDate(to);
  };

  return (
    <Dialog open={open} onClose={() => onClose()}>
      <DialogTitle>Štampa</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ marginBottom: "24px" }}>
          Odaberite vremenski period koji želite da odštampate:
        </DialogContentText>
        <DatePicker
          variant="range"
          value={[fromDate, toDate]}
          format="ddd, DD.MM.yyyy"
          onChange={(value) => setPrintDates(value[0], value[1])}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()}>Zatvori</Button>
        <Button
          color="primary"
          variant="contained"
          startIcon={<PrintIcon />}
          onClick={() => goToPrint()}
        >
          Štampa
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PrintDialog;
